module.exports = __webpack_public_path__ + "71a7161938719b3c783ab1be9d9ca742.svg";